import { useFormikContext } from "formik";
import { Button } from "reactstrap";

import type { FormValues } from "./types";

interface LandingPageModalActionsProps {
  onClose?: () => void;
}

export const LandingPageModalActions = ({
  onClose,
}: LandingPageModalActionsProps) => {
  const { isSubmitting, isValid } = useFormikContext<FormValues>();

  return (
    <>
      <Button color="secondary" outline onClick={onClose}>
        Cancel
      </Button>
      <Button color="dark" type="submit" disabled={isSubmitting || !isValid}>
        {isSubmitting ? "Saving..." : "Save"}
      </Button>
    </>
  );
};
